<template>
  <div class="container">
    <div class="survey">
      <div class="user-panel">
        <h2 class="user-item">{{ parseTranslation(USER_LIST) }}</h2>
        <div class="user-list" id="userList">
          <ul class="user-item">
            <li v-for="user in orderedUsers" :key="user.username" class="user">
              <a
                :title="user.username"
                @click="selectUser(user, $event)"
                href="#"
                class="userBtn"
              >
                {{ user.username }}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <survey-list
        class="survey-list"
        @selectedUser="selectUser"
        v-if="selectedUser"
        :user="selectedUser"
        :users="users"
        :surveys="selectedSurveys"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import SurveyList from './SurveyList'

import * as translationAdminSurvey from './index.translations'

const { default: translations, ...translationKeys } = translationAdminSurvey

export default {
  name: 'users',

  props: {
    users: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      translations,
      ...translationKeys,
      selectedUser: '',
      selectedSurveys: [],
    }
  },

  components: {
    SurveyList,
  },

  computed: {
    orderedUsers() {
      function compare(a, b) {
        if (a.username.toLowerCase() < b.username.toLowerCase()) return -1
        return 0
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.users.sort(compare)
    },
  },

  methods: {
    ...mapActions(['sendMessage', 'executeSurveyAPICall']),

    async selectUser(user, e) {
      const surveys = await this.executeSurveyAPICall({
        path: 'survey/admin/list',
        queryParams: { username: user.username },
      })

      if (!surveys) return

      this.selectedUser = user
      this.selectedSurveys = surveys

      if (e !== undefined) this.displaySelected(e)
    },

    displaySelected(e) {
      const users = document.querySelectorAll('.user')

      users.forEach(anchor => {
        anchor === e.target.parentElement
          ? anchor.classList.add('active')
          : anchor.classList.remove('active')
      })
    },
  },

  mounted() {
    const users = document.querySelectorAll('.userBtn')
    if (users.length) users[0].click()
  },
}
</script>

<style lang="scss" scoped>
.survey {
  display: flex;
  margin: 0 auto;
  margin-top: 60px;
}

.user-panel {
  display: flex;
  align-items: center;
  align-content: flex-end;
  flex-direction: column;
  min-height: 100px;
  height: unset;
  padding: 0 10px;
  h2 {
    @include tipography(18);
    height: 20px;
    text-align: center;
    font-weight: bold;
  }
  .light & {
    h2 {
      color: $gray-6;
    }
  }
}

.user-list {
  width: 100%;
  max-height: calc(100vh - 310px);
  overflow-y: auto;
  overflow-x: hidden;
  border-right: 1px solid $white;
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-track {
    background: $white-3;
  }
  &::-webkit-scrollbar-thumb {
    background: $gray-10;
    border-radius: 5px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: $gray-11;
  }
  .light & {
    border-right: 1px solid $gray-5;
  }
}

.survey-list {
  max-height: calc(100vh - 270px);
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-track {
    background: $white-3;
  }
  &::-webkit-scrollbar-thumb {
    background: $gray-10;
    border-radius: 5px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: $gray-11;
  }
  padding: 0 20px;
}
.user-item {
  padding-bottom: 40px;
  li {
    display: flex;
    justify-content: center;
    cursor: pointer;
    @include tipography(16);
    position: relative;
    transition: all 0.5s ease-in-out;
    &:hover,
    &.active {
      background: rgba(255, 255, 255, 0.1);
    }
    a {
      color: $white;
      text-align: center;
      height: 100%;
      width: 100%;
      display: block;
      padding: 15px 0;
      max-width: 31ch;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .light & {
    li {
      &:hover,
      &.active {
        background: rgba(0, 0, 0, 0.1);
      }
      a {
        color: $gray-6;
      }
    }
  }
}

@media (max-width: 767.98px) {
  .survey {
    display: block;
    .user-panel {
      margin-bottom: 70px;
    }
  }

  .user-item {
    li {
      a {
        max-width: 45ch;
      }
    }
  }

  .survey-list {
    padding: 0 5px;
  }
}
</style>
